













































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import JSwitch from '@/components/common/JSwitch.vue'
import $Api from '@api'
import { AccountPageRecord, AccountState,} from '@/api/model/account'
import { finalize } from 'rxjs/operators'
import AddForm from './addForm.vue'
import RechargeDialog from './RechargeDialog.vue'
import { translate, DateTime } from '@/utils/filters'

@Component({
    components: {
        SearchForm,
        TableForm,
        JSwitch,
        AddForm,
        RechargeDialog
    }
})
export default class Company extends Vue {
    dateTime = DateTime
    total = 0
    formEl: any
    tableData: AccountPageRecord[] = []
    tableLoading: boolean = false
    searchForm = {
        current: 1,
        size: 10,
        state: ''
    }
    isShownDialog: boolean = false
    isShownRechargelDialog: boolean = false
    isEdit: boolean = false
    dialogFormVisible: boolean = false
    filterList = []
    loading: boolean = false
    dialogFormData = {}
    rechargeFormData = {}

    created(): void {
        this.getData()

    }

    getData(pageQuery = {}): void {
        Object.assign(this.searchForm, pageQuery)
        this.tableLoading = true

        $Api.accountService
            .accountPage(this.searchForm)
            .pipe(finalize(() => (this.tableLoading = false)))
            .subscribe(res => {
                this.tableData = res.records
                this.total = res.total
            })
    }
    
    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    addAccount(): void {
        this.isShownDialog = true
        this.dialogFormData = {}
    }

    recharge(row: AccountPageRecord): void {
        this.isShownRechargelDialog = true
        this.dialogFormData = row
    }

    editAccount(row: AccountPageRecord): void {
        this.isShownDialog = true
        this.dialogFormData = row
        this.isEdit = true
    }

    updateState(row: AccountPageRecord): void {
        const { state, id } = row
        let stateReversed
        let stateTxt
        if (AccountState.ENABLE === state) {
            stateReversed = AccountState.DISABLE
            stateTxt = translate('nav.account.company.searchForm.stateValue.disable')
        } else {
            stateReversed = AccountState.ENABLE
            stateTxt = translate('nav.account.company.searchForm.stateValue.enable')
        }

        this.$confirm(translate('nav.account.item.confirm.state', { state: stateTxt }), translate('common.tip'), {
            confirmButtonText: translate('common.btn.confirm'),
            cancelButtonText: translate('common.btn.cancel')
        })
            .then(action => {
                const state = +stateReversed
                $Api.accountService.updateState({ id, state }).subscribe(res => {
                    row.state = stateReversed
                })
            })
            .catch(() => {})
    }

    hideDialog(): void {
        this.isShownDialog = false
        this.isEdit = false
        this.isShownRechargelDialog = false
    }
}
